module.exports = __webpack_public_path__ + "img/tb-3.1d436fe7.png";